import {getCookie} from '../../utils/cookies'
import {visitsCountConfig} from './cookieConfig'

export const getVisitsCount = () => Number(getCookie(visitsCountConfig.name))
